import { BasedB2CTransactionRequestModel } from "app/based/baseApiModel/baseTransactionHistory/basedB2CTransaction/BasedB2CTransactionRequestModel";

export class BalanceRegistrationRequestEntity extends BasedB2CTransactionRequestModel {
  code?: string;
  created?: Record<string, unknown>[];
  fromDate?: string;
  limit?: number;
  page?: number;
  platform?: string;
  status?: string;
  toDate?: string;
  type?: string;

  constructor(data?: Partial<BalanceRegistrationRequestEntity>) {
    super(data);
    Object.assign(this, data);
  }
}
